import React from 'react';

import { connect } from  'react-redux';

import { Redirect, Link } from 'react-router-dom';

import {api} from '../../actions/_request';
import swal from 'sweetalert2';
//libs
import Select , {Async}  from 'react-select';
import moment from 'moment';

import Lista_tickets from './lista_tickets_contpaq'
import * as actions from '../../actions/participaciones';

import {
    Card, CardBlock,
    Button, ButtonGroup,
    InputGroup, InputGroupAddon, InputGroupButton,InputGroupText,
    Input,
    Badge,
    Row,
    CardTitle
} from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink, CardText, Col } from 'reactstrap';
import classnames from 'classnames';

class ParticipacionesContpaq extends React.Component{

	constructor(props){
		super(props)

		this.state = {
			contpaq : {
				id:null,
				fecha:'',
				ventas:0,
				soporte:0,
				distribuidores:0,
				ingreso_total:0,
				gastos_fijos:68000,
				gasto_eventos : 0,
				viaticos : 0,
				gasolina_adicional : 0,
				otros : 0,
				comision_personal : 0,
				rebate_general  : 0,
				porcentaje_rebate:40,
				rebate_total : 0,
				gasto_total : 0,
				utilidad_bruta:0,
				impuesto:20,
				utilidad_neta:0,
			    porcentaje_ana:40,
			    participacion_ana:0,
			    isr_ana:0,
			    telcel_ana:0,
			    total_ana:0,
			    porcentaje_ariana:20,
			    participacion_ariana:0,
			    isr_ariana:0,
			    telcel_ariana:0,
			    total_ariana:0,
			},
			 activeTab: '1',
		}
		this.handleInputChange = this.handleInputChange.bind(this);
		this.sumar = this.sumar.bind(this);
		this.guardar = this.guardar.bind(this);
		this.toggle_tab= this.toggle_tab.bind(this);
	}
	toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }

		formateo(value) {
			var decimals =  2;
			var  separators =[',', ",", '.'];
			var number = (parseFloat(value) || 0).toFixed(decimals);
			if (number.length <= (4 + decimals))
			return '$' +number.replace('.', separators[separators.length - 1]);
			var parts = number.split(/[-.]/);
			value = parts[parts.length > 1 ? parts.length - 2 : 0];
			var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
			separators[separators.length - 1] + parts[parts.length - 1] : '');
			var start = value.length - 6;
			var idx = 0;
			while (start > -3) {
			result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
			+ separators[idx] + result;
			idx = (++idx) % 2;
			start -= 3;
			}
			return '$' + result;
		}
		formateo_input(value) {
			var decimals =  2;
			var  separators =[',', ",", '.'];
			var number = (parseFloat(value) || 0).toFixed(decimals);
			if (number.length <= (4 + decimals))
			return '' +number.replace('.', separators[separators.length - 1]);
			var parts = number.split(/[-.]/);
			value = parts[parts.length > 1 ? parts.length - 2 : 0];
			var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
			separators[separators.length - 1] + parts[parts.length - 1] : '');
			var start = value.length - 6;
			var idx = 0;
			while (start > -3) {
			result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
			+ separators[idx] + result;
			idx = (++idx) % 2;
			start -= 3;
			}
			return '' + result;
		}

	guardar(){
		console.log('entro');
   let contpaq = this.state.contpaq;
   console.log('contpaq--->',contpaq);
   let self = this;
		if(contpaq.id==null){

			this.props.save(contpaq, (response) => {
				
							
					self.setState({contpaq : response});
					console.log('contpaq regresado--->',contpaq);

					swal("Bien hecho!", "El reporte fue Registrado  con éxito!", "success");
				

			});

		}else{
			this.props.update(contpaq, (response) => {
				
							
					self.setState({contpaq : response});
					console.log('contpaq regresado--->',contpaq);
					swal("Bien hecho!", "El reporte fue actualizado  con éxito!", "success");


			});

		}

	}
	 componentDidMount(){
	  let self = this;

	 	api().get(this.props.ruta)
        .then(function(response)
        {
              if(parseInt(response.data.tipo)===1){
              	 self.setState({
                contpaq : response.data.participacion[0],
                 });  

              }else
              {
              	 self.setState({
	                contpaq : {
					id:null,
					fecha:response.data.fecha,
					ventas:response.data.ventas,
					soporte:response.data.servicios,
					distribuidores:response.data.distribuidores,
					ingreso_total:0,
					gastos_fijos:68000,
					gasto_eventos : 0,
					viaticos : 0,
					gasolina_adicional : 0,
					otros : 0,
					comision_personal : response.data.comision_personal,
					rebate_general  : response.data.rebate_general,
					porcentaje_rebate:40,
					rebate_total : 0,
					gasto_total : 0,
					utilidad_bruta:0,
					impuesto:20,
					utilidad_neta:0,
				    porcentaje_ana:40,
				    participacion_ana:0,
				    isr_ana:0,
				    telcel_ana:0,
				    total_ana:0,
				    porcentaje_ariana:20,
				    participacion_ariana:0,
				    isr_ariana:0,
				    telcel_ariana:0,
				    total_ariana:0,
				}
                 }); 

              }
              self.sumar();

           
		});

        
        console.log("componentDidMount")
    }
    componentWillReceiveProps(nextProps)
    {
         let self = this;

	 	api().get(this.props.ruta)
        .then(function(response)
        {
              if(parseInt(response.data.tipo)===1){
              	 self.setState({
                contpaq : response.data.participacion[0],
                 });  

              }else
              {
              	 self.setState({
                contpaq : {
				id:null,
				ventas:response.data.ventas,
				soporte:response.data.servicios,
				distribuidores:response.data.distribuidores,
				ingreso_total:0,
				gastos_fijos:68000,
				gasto_eventos : 0,
				viaticos : 0,
				gasolina_adicional:0,	
				otros : 0,
				comision_personal : 0,
				rebate_general  : 0,
				porcentaje_rebate:40,
				rebate_total : 0,
				gasto_total : 0,
				utilidad_bruta:0,
				impuesto:20,
				utilidad_neta:0,
			    porcentaje_ana:40,
			    participacion_ana:0,
			    isr_ana:0,
			    telcel_ana:0,
			    total_ana:0,
			    porcentaje_ariana:20,
			    participacion_ariana:0,
			    isr_ariana:0,
			    telcel_ariana:0,
			    total_ariana:0,
			}
                 }); 

              }
              self.sumar();

           
		});

         console.log("componentWillReceiveProps")
   
    }

    quitar_comas(value){
    	let numero=''+value;
    	let output =numero.replace(',', '');
    	return output;

    }

	handleInputChange(event) {



		if(event === null) return;
        let{contpaq} = this.state;
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;
		let converted;
		converted = parseFloat( value,10);
		console.log('converted----->',converted)

		if(value== '' ||  isNaN(converted)){
			converted = '';
			console.log('vacio');
		}
		console.log('converted despues----->',converted)
		console.log('name-->',name);


		contpaq[name] = converted;
		this.setState({contpaq: contpaq});

		

		 this.sumar();


	}

	sumar(){
		let{contpaq} = this.state;
		contpaq.ingreso_total=(parseFloat(contpaq.ventas,10)+parseFloat(contpaq.soporte,10)+parseFloat(contpaq.distribuidores,10)).toFixed(2);

		let gastos_fijos=contpaq.gastos_fijos;
		if(isNaN(gastos_fijos)||gastos_fijos== ''){
		    	gastos_fijos=0;	    	
		    }
		    console.log('gastos_fijos--->',gastos_fijos);
		let eventos=contpaq.gasto_eventos;
		if(isNaN(eventos)||eventos== ''){
		    	eventos=0;	    	
		    }
		    console.log('eventos--->',eventos);

		let viaticos=contpaq.viaticos;
		if(isNaN(viaticos)||viaticos== ''){
		    	viaticos=0;	    	
		    }
		    console.log('viaticos--->',viaticos);

		let gasolina_adicional=contpaq.gasolina_adicional;
		if(isNaN(gasolina_adicional)||gasolina_adicional== ''){
		    	gasolina_adicional=0;	    	
		    }
		    console.log('gasolina_adicional--->',gasolina_adicional);

		let otros=contpaq.otros;
		if(isNaN(otros)||otros== ''){
		    	otros=0;	    	
		    }
		    console.log('otros--->',otros);
		let comision_personal=contpaq.comision_personal;
		if(isNaN(comision_personal)||comision_personal== ''){
		    	comision_personal=0;	    	
		    }
		    console.log('comision_personal--->',comision_personal);
		let rebate_general=contpaq.rebate_general;
		if(isNaN(rebate_general)||rebate_general== ''){
		    	rebate_general=0;	    	
		    }
		    console.log('rebate_general--->',rebate_general);


		    contpaq.rebate_total=(rebate_general*(parseFloat(contpaq.porcentaje_rebate,10)/100)).toFixed(2);
		    console.log('rebate_total--->', contpaq.rebate_total);
		    contpaq.gasto_total=(gastos_fijos+eventos+viaticos+gasolina_adicional+otros+comision_personal+parseFloat(contpaq.rebate_total,10)).toFixed(2);
		    if(contpaq.gasto_total<0)
			   contpaq.gasto_total=0;

		    contpaq.utilidad_bruta=(parseFloat( contpaq.ingreso_total,10)-parseFloat(contpaq.gasto_total,10)).toFixed(2);
		     if(contpaq.utilidad_bruta<0)
			   contpaq.utilidad_bruta=0;

		    let impuesto=(parseFloat(contpaq.utilidad_bruta,10)*(contpaq.impuesto/100)).toFixed(2);

		    contpaq.utilidad_neta=(contpaq.utilidad_bruta- parseFloat( impuesto,10)).toFixed(2);
		     if(contpaq.utilidad_neta<0)
			    	contpaq.utilidad_neta=0;

		    contpaq.participacion_ana=(parseFloat(contpaq.utilidad_neta,10)*(parseFloat(contpaq.porcentaje_ana,10)/100)).toFixed(2);
		    contpaq.participacion_ariana=(parseFloat(contpaq.utilidad_neta,10)*(parseFloat(contpaq.porcentaje_ariana,10)/100)).toFixed(2);

		    let isr_ana=parseFloat(contpaq.isr_ana,10);
			if(isNaN(isr_ana)){
			    	isr_ana=0;	    	
			    }
			let telcel_ana=parseFloat(contpaq.telcel_ana,10);
			if(isNaN(telcel_ana)){
			    	telcel_ana=0;	    	
			    }

			    let isr_ariana=parseFloat(contpaq.isr_ariana,10);
			if(isNaN(isr_ariana)){
			    	isr_ariana=0;	    	
			    }
			let telcel_ariana=parseFloat(contpaq.telcel_ariana,10);
			if(isNaN(telcel_ariana)){
			    	telcel_ariana=0;	    	
			    }

			    contpaq.total_ana=parseFloat(contpaq.participacion_ana,10)-telcel_ana-isr_ana;
			    contpaq.total_ariana=parseFloat(contpaq.participacion_ariana,10)-telcel_ariana-isr_ariana;
			    if(contpaq.total_ariana<0)
			    	contpaq.total_ariana=0;
			     if(contpaq.total_ana<0)
			    	contpaq.total_ana=0;


	

		this.setState({
			contpaq: contpaq
		});


	}

	render(){

		let {contpaq} = this.state;
		
		// let rebate_total = contpaq.rebate_general !== ''? parseFloat(contpaq.rebate_general,10)*.40 : 0;
		// console.log('rebate total -->',rebate_total)
		// let gasto_total  = contpaq.gasto_eventos+contpaq.viaticos+contpaq.gasolina_adicional+contpaq.otros + rebate_total;
		// console.log(gasto_total)
		return(
            <Card className="px-3">
            <div className="mb-2"></div>
            <Nav tabs>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '1' })}
                          onClick={() => { this.toggle_tab('1'); }}
                        >
                          Reporte
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '2' })}
                          onClick={() => { this.toggle_tab('2'); }}
                        >
                         Lista Tickets
                        </NavLink>
                      </NavItem>
                    </Nav>

                     <TabContent activeTab={this.state.activeTab}>
                      <TabPane tabId="1">
                        <Row>
                          <Col sm="12" >
                          	<div className="row mt-4">
					<div className="col-2">
						<div className="form-group">
							<label className>Utilidad de Ventas Max</label>
							<input
								type="text" 
								className="form-control"
								name="ventas"
								readOnly
								value={this.formateo(contpaq.ventas)}
								onChange={this.handleInputChange}
								
							/>
						</div>
					</div>
					<div className="col-2">
						<div className="form-group">
							<label className>Utilidad de Soporte Max</label>
							<input
								type="text" 
								className="form-control"
								name="soporte"
								readOnly
								value={this.formateo(contpaq.soporte)}
								onChange={this.handleInputChange}
								
							/>
						</div>
					</div>
					<div className="col-2">
						<div className="form-group">
							<label className>Utilidad de Distribuidores</label>
							<input
								type="text" 
								className="form-control"
								name="distribuidores"
								readOnly
								value={this.formateo(contpaq.distribuidores)}
								onChange={this.handleInputChange}
								
							/>
						</div>
					</div>
					
				
					<div className="col-2">
						<div className="form-group">
							<label className>Ingreso Total</label>
							<input
								type="text" 
								className="form-control"
								name="ingreso_total"
								placeholder={this.formateo(contpaq.ingreso_total)}
								readOnly
							/>
						</div>
					</div>
				</div>
			
			<br/><br/>
			
				<div className="row">
				<div className="col-2">
						<div className="form-group">
							<label className>Gastos fijos</label>
							<InputGroup>
							<InputGroupAddon>$</InputGroupAddon>
						        <input
									type="number" 
									className="form-control"
									name="gastos_fijos"
									value={contpaq.gastos_fijos}
									onChange={this.handleInputChange}
								/>
						        
						    </InputGroup>
							
						</div>
					</div>
					<div className="col-2">
						<div className="form-group">
							<label className>Gasto de eventos</label>
							<InputGroup>
							<InputGroupAddon>$</InputGroupAddon>
						        <input
									type="number" 
									className="form-control"
									name="gasto_eventos"
									value={(contpaq.gasto_eventos)}
									onChange={this.handleInputChange}
								/>
						        
						    </InputGroup>
							
						</div>
					</div>
					<div className="col-2">
						<div className="form-group">
							<label className>Viaticos</label>
							<InputGroup>
							<InputGroupAddon>$</InputGroupAddon>
						        <input
									type="number" 
									className="form-control"
									name="viaticos"
									value={(contpaq.viaticos)}
									onChange={this.handleInputChange}
								/>
						        
						    </InputGroup>
							
						</div>
					</div>
					<div className="col-2">
						<div className="form-group">
							<label className>Gasolina Adicional</label>
							<InputGroup>
							<InputGroupAddon>$</InputGroupAddon>
						        <input
									type="number" 
									className="form-control"
									name="gasolina_adicional"
									value={(contpaq.gasolina_adicional)}
									onChange={this.handleInputChange}
								/>
						        
						    </InputGroup>
						</div>
					</div>
					<div className="col-2">
						<div className="form-group">
							<label className>Otros</label>
							<InputGroup>
							<InputGroupAddon>$</InputGroupAddon>
						        <input
									type="number" 
									className="form-control"
									name="otros"
									value={(contpaq.otros)}
									onChange={this.handleInputChange}
								/>
						        
						    </InputGroup>
						
						</div>
					</div>
					<div className="col-2">
						<div className="form-group">
							<label className>Comisiones Personal</label>
							<input
								type="number" 
								className="form-control"
								name="comision_personal"
								value={this.formateo(contpaq.comision_personal)}
								onChange={this.handleInputChange}
								readOnly
							/>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-4">
						<label className>Rebate General</label>
						<InputGroup>
					        <input
								type="text" 
								className="form-control"
								name="rebate_general"
								value={this.formateo(contpaq.rebate_general)}
								onChange={this.handleInputChange}
								readOnly
							/>
					        <InputGroupAddon>X</InputGroupAddon>
					        <input
								type="text" 
								className="form-control"
								name="rebate_general"
								value={'40%'}
								readOnly
								onChange={this.handleInputChange}
							/>
							<InputGroupAddon>=</InputGroupAddon>
							<input
								type="text" 
								className="form-control"
								name="rebate_total"
								value={this.formateo(contpaq.rebate_total)}
								readOnly
								onChange={this.handleInputChange}
							/>
					    </InputGroup>
					</div>
				</div>
				<div className="row">
					<div className="col-2">
						<div className="form-group">
							<label className>Gasto Total</label>
							<input
								type="text" 
								className="form-control"
								name="gasto_total"
								placeholder={this.formateo(contpaq.gasto_total)}
								readOnly
							/>
						</div>
					</div>
				</div>
			<br/><br/>
			
				<div className="row">
					<div className="col-2">
						<div className="form-group">
							<label className>Utilidad Bruta</label>
							<input
								type="text" 
								className="form-control"
								name="ventas"
								readOnly
								value={this.formateo(contpaq.utilidad_bruta)}
								onChange={this.handleInputChange}
								
							/>
						</div>
					</div>
					<div className="col-4">
						<label className>Utilidad Neta</label>
						<InputGroup>
					        <InputGroupAddon>-</InputGroupAddon>
					        <input
								type="text" 
								className="form-control"
								name="rebate_general"
								value={contpaq.impuesto+'%'}
								readOnly
								onChange={this.handleInputChange}
							/>
							<InputGroupAddon>=</InputGroupAddon>
							<input
								type="text" 
								className="form-control"
								name="utilidad_neta"
								readOnly
								value={this.formateo(contpaq.utilidad_neta)}
								onChange={this.handleInputChange}
							/>
					    </InputGroup>
					</div>

				</div>
		
			<br/><br/>

		
				<div className="row">
				<div className="col-12">
							<label className="mt-4 ml-4">Ana Marina Nuza</label>
						
						</div>
						</div>
					<div className="row">
						<div className="col-4">
							<label className>Utilidad Neta</label>
							<InputGroup>
						        <input
									type="text" 
									className="form-control"
									readOnly
									value={this.formateo(contpaq.utilidad_neta)}
									onChange={this.handleInputChange}
								/>
						        <InputGroupAddon>X</InputGroupAddon>

						        <input
									type="text" 
									className="form-control"
									name="porcentaje_ana"
									value={contpaq.porcentaje_ana+'%'}
									readOnly
									onChange={this.handleInputChange}
								/>
								<InputGroupAddon>=</InputGroupAddon>
						    </InputGroup>
						</div>
						<div className="col-2">
						<div className="form-group">
							<label className>Participaiones</label>
							<input
								type="text" 
								className="form-control"
								readOnly
								value={this.formateo(contpaq.participacion_ana)}
							    onChange={this.handleInputChange}
								
							/>
						</div>
					</div>
					<div className="col-2">
						<div className="form-group">
							<label className>ISR</label>
							<InputGroup>
							<InputGroupAddon>$</InputGroupAddon>
						        <input
									type="number" 
									className="form-control"
									name="isr_ana"
									value={(contpaq.isr_ana)}
									onChange={this.handleInputChange}
								/>						        
						    </InputGroup>
						</div>
					</div>

					<div className="col-2">
						<div className="form-group">
							<label className>Telcel</label>
							<InputGroup>
							<InputGroupAddon>$</InputGroupAddon>
						        <input
									type="number" 
									className="form-control"
									name="telcel_ana"
									value={(contpaq.telcel_ana)}
									onChange={this.handleInputChange}
								/>
						        
						    </InputGroup>
						</div>
					</div>
					<div className="col-2">
						<div className="form-group">
							<label className>Total</label>
							<input
								type="text" 
								className="form-control"
								name="gasto_eventos"
								readOnly
								value={this.formateo(contpaq.total_ana)}
							    onChange={this.handleInputChange}
								
							/>
						</div>
					</div>




					</div>
					<div className="row">
				<div className="col-12">
							<label className="mt-4 ml-4">Ariana Heras</label>
						
						</div>
						</div>
					<div className="row">
						<div className="col-4">
							<label className>Utilidad Neta</label>
							<InputGroup>
						        <input
									type="text" 
									className="form-control"
									readOnly
									value={this.formateo(contpaq.utilidad_neta)}
									onChange={this.handleInputChange}
								/>
						        <InputGroupAddon>X</InputGroupAddon>

						        <input
									type="text" 
									className="form-control"
									name="ress"
									value={contpaq.porcentaje_ariana+'%'}
									readOnly
									
								/>
								<InputGroupAddon>=</InputGroupAddon>
						    </InputGroup>
						</div>
						<div className="col-2">
						<div className="form-group">
							<label className>Participaiones</label>
							<input
								type="text" 
								className="form-control"
								name="participacion_ariana"
								readOnly
								value={this.formateo(contpaq.participacion_ariana)}
							    onChange={this.handleInputChange}
								
							/>
						</div>
					</div>
					<div className="col-2">
						<div className="form-group">
							<label className>ISR</label>


							<InputGroup>
							<InputGroupAddon>$</InputGroupAddon>
						        <input
									type="number" 
									className="form-control"
									name="isr_ariana"
									value={(contpaq.isr_ariana)}
									onChange={this.handleInputChange}
								/>						        
						    </InputGroup>
						</div>
					</div>

					<div className="col-2">
						<div className="form-group">
							<label className>Telcel</label>
							<InputGroup>
							<InputGroupAddon>$</InputGroupAddon>
						        <input
									type="number" 
									className="form-control"
									name="telcel_ariana"
									value={(contpaq.telcel_ariana)}
									onChange={this.handleInputChange}
								/>
						        
						    </InputGroup>
						</div>
					</div>
					<div className="col-2">
						<div className="form-group">
							<label className>Total</label>
							<input
								type="text" 
								className="form-control"
								name="total_ariana"
								value={this.formateo(contpaq.total_ariana)}
								readOnly
							    onChange={this.handleInputChange}
								
							/>
						</div>
					</div>




					</div>
			
			<br/><br/>
			<div className="row">
				<div className="col-12 text-right">

					<Button color="success"  onClick={this.guardar} >
                    			&nbsp;Guardar
                    		</Button>
				</div>
			</div>

			<br/><br/>
                         
                           
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="2">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 h-300">
                            <div className="col-md-12">
                                <Lista_tickets departamento={2} mes={this.props.mes} ano={this.props.ano}/>
                            </div>                                   
                                                      
                        </div>                          
                          </Col>
                        </Row>
                      </TabPane>                      
                    </TabContent>
			
			







			</Card>

		)
	}
}

function mapStateToProps(state, ownProps) {
    return {
        ticket : state.ticket,
        auth:state.auth
    }
};

export default connect(mapStateToProps, actions)(ParticipacionesContpaq)


// WEBPACK FOOTER //
// ./src/views/reportes/participacionesContpaq.js